import {
  Button,
  CaretUpOutlinedIcon,
} from '@trufla-technology/trumarket-react-design-system';
import './style.scss';
import { useHistory } from 'react-router-dom';

interface IProps {
  step: number;
  handleNext?: () => void;
  disableFinish?: boolean;
  handlePrevious?: () => void;
}

export const CreateWebsiteSteps = (props: IProps) => {
  const history = useHistory();
  const { step, disableFinish, handlePrevious } = props;

  return (
    <div className="create-system-configuration-steps">
      <h2>truWeb Configuration</h2>
      <div className="steps">
        <p className={props.step >= 1 ? 'active' : ''}>Details</p>
        <span className="icon">
          <CaretUpOutlinedIcon
            width="18px"
            fill={
              step + 1 >= 2 ? 'var(--tru-primary-color)' : 'var(--tru-grey)'
            }
          />
        </span>
        <p className={step >= 2 ? 'active' : ''}>Deployment</p>
        <span className="icon">
          <CaretUpOutlinedIcon
            width="18px"
            fill={
              step + 1 >= 3 ? 'var(--tru-primary-color)' : 'var(--tru-grey)'
            }
          />
        </span>
        <p className={step >= 3 ? 'active' : ''}>Finish</p>
      </div>
      <Button
        type="outlined"
        onClick={() => {
          if (handlePrevious) {
            handlePrevious();
          } else {
            history.goBack();
          }
        }}
        htmlType="button"
      >
        {step > 1 ? 'Previous' : 'Cancel'}
      </Button>
      <Button type={disableFinish ? 'disabled' : 'primary'} htmlType="submit">
        {step === 3 ? 'Finish' : 'Next'}
      </Button>
    </div>
  );
};
